import type { SignatureV2Participant, SignatureV2Side, SignatureV2Step, SignatureV2Workflow } from '@/types/signatureV2';

export type SignerRow = {
  workflow: SignatureV2Workflow;
  partySide: SignatureV2Side;
  participant: SignatureV2Participant;
  step?: SignatureV2Step;
};

export const groupSignatureV2Signers = (workflow: SignatureV2Workflow) => {
  const platform: Record<SignatureV2Side, SignerRow[]> = { buyer: [], seller: [] };
  const external: SignerRow[] = [];
  const stepsByParticipant = new Map(workflow.steps.map((step) => [step.participant_id, step]));

  for (const party of workflow.parties) {
    for (const participant of party.participants) {
      const row = {
        workflow,
        partySide: party.side,
        participant,
        step: stepsByParticipant.get(participant.id),
      };
      (participant.is_external ? external : platform[party.side]).push(row);
    }
  }

  for (const side of ['buyer', 'seller'] as const) {
    platform[side].sort((first, second) => first.participant.position - second.participant.position);
  }

  external.sort((first, second) => {
    const firstSide = first.partySide === 'buyer' ? 0 : 1;
    const secondSide = second.partySide === 'buyer' ? 0 : 1;
    if (first.step && second.step) return first.step.sequence - second.step.sequence;
    return firstSide - secondSide || first.participant.position - second.participant.position;
  });

  return { platform, external };
};
